module.exports = __webpack_public_path__ + "static/product1_3-ca4789fa65ba307b3b1ee4f37b32cb4a.jpg";